document.addEventListener('DOMContentLoaded', function () {
  function syncCartMinusButtons() {
    document.querySelectorAll('.cart-item__quantity-wrapper .quantity__input').forEach(function (input) {
      var wrapper = input.closest('.quantity, quantity-input');
      if (!wrapper) return;
      var minusBtn = wrapper.querySelector('button[name="minus"]');
      if (!minusBtn) return;
      var val = parseInt(input.value, 10) || 0;
      minusBtn.disabled = val <= 1;
      minusBtn.classList.toggle('disabled', val <= 1);
    });
  }

  syncCartMinusButtons();

  // GUARD: intercept the click itself, before Dawn's own handler runs,
  // using capture phase so this fires first. This closes the race
  // condition entirely — no dependency on Dawn's async timing.
  document.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('.cart-item__quantity-wrapper button[name="minus"]');
    if (!minusBtn) return;

    var wrapper = minusBtn.closest('.quantity, quantity-input');
    var input = wrapper ? wrapper.querySelector('.quantity__input') : null;
    if (!input) return;

    var val = parseInt(input.value, 10) || 0;
    if (val <= 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true); // capture phase — runs before Dawn's own listener

  document.addEventListener('change', function (e) {
    if (e.target.matches('.cart-item__quantity-wrapper .quantity__input')) {
      setTimeout(syncCartMinusButtons, 300);
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cart-item__quantity-wrapper .quantity__button')) {
      setTimeout(syncCartMinusButtons, 300);
    }
  });

  var stableRoot = document.getElementById('CartDrawer');
  if (stableRoot) {
    var debounceTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncCartMinusButtons, 200);
    });
    observer.observe(stableRoot, { childList: true, subtree: true });
  }
});